import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type GetNotificationHistoryQueryPayload, type GetNotificationHistoryQueryResponse } from './types'

export const getNotificationHistoryQuery = (payload: GetNotificationHistoryQueryPayload) =>
  queryOptions({
    queryKey: [API_ENDPOINTS.notification.v1.history.index, payload],
    queryFn: (): Promise<GetNotificationHistoryQueryResponse> =>
      w.post(payload, API_ENDPOINTS.notification.v1.history.index).json(),
    placeholderData: keepPreviousData,
  })
